<ion-grid [class.mobile]="platform === platformRef.mobile">
  <div class="sub-menu-container" *ngIf="platform !== platformRef.mobile">
    <div
      *ngFor="let item of items"
      (click)="onClick(item)"
      [attr.data-cy]="'sub-menu' + item.tag"
      class="sub-menu-item"
      [class.selected]="item.isSelected"
      [class.tablet]="platform === platformRef.tablet"
    >
      {{ item.label | translate }}
    </div>
  </div>

  <div class="sub-menu-dropdown" *ngIf="platform === platformRef.mobile">
    <ion-button
      data-cy="sub-menu-button"
      class="usf-outline-green-button"
      (click)="openMenu()"
    >
      <ion-label>
        <span>
          {{ currentPage | translate }}
        </span>
        <ion-icon name="chevron-down"></ion-icon>
      </ion-label>
    </ion-button>
  </div>
</ion-grid>

<ion-modal
  [isOpen]="isOpen"
  [initialBreakpoint]="platform !== platformRef.desktop ? 1 : undefined"
  [breakpoints]="platform !== platformRef.desktop ? [0, 1] : undefined"
  (ionModalDidDismiss)="closeMenu()"
  [ngClass]="'ion-modal-touch'"
>
  <ng-template>
    <app-sub-menu-modal
      [items]="items"
      (dismissEvent)="closeMenu()"
      (submitEvent)="onClick($event)"
    >
    </app-sub-menu-modal>
  </ng-template>
</ion-modal>
